<template>
  <div class="v-wms-feature-info">
    <div
      v-if="props.mapModule.reactiveData.isLoadingFeatureInfo"
      class="v-wms-feature-info__loading"
    >
      Laden…
    </div>
    <div
      v-else-if="props.mapModule.reactiveData.featureInfoError"
      class="v-wms-feature-info__error"
    >
      {{ props.mapModule.reactiveData.featureInfoError }}
    </div>
    <pre
      v-else-if="props.mapModule.reactiveData.featureInfoResult"
      class="v-wms-feature-info__result"
    >{{
            JSON.stringify(props.mapModule.reactiveData.featureInfoResult, null, 2)
    }}</pre>
    <div
      v-else
      class="v-wms-feature-info__empty"
    >
      Keine Informationen gefunden.
    </div>
  </div>
</template>

<script setup lang="ts">
import type { WmsMapModule } from "./WmsMapModule";

const props = defineProps<{
    mapModule: WmsMapModule;
}>();
</script>
